"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableUtilsEx = void 0;
var boundary_1 = require("@devexpress/utils/lib/intervals/boundary");
var list_1 = require("@devexpress/utils/lib/utils/list");
var TableUtilsEx = (function () {
    function TableUtilsEx() {
    }
    TableUtilsEx.getColumnsRangeBySelectedRow = function (gridInfoManager, rowInfo) {
        var rowGridInfo = gridInfoManager.tableCellInfos[rowInfo.rowIndex];
        var lastCellInfo = list_1.ListUtils.last(rowInfo.cells);
        return new boundary_1.BoundaryInterval(rowGridInfo[rowInfo.cells[0].cellIndex].getGridCellIndex(), rowGridInfo[lastCellInfo.cellIndex].getGridCellIndex() + lastCellInfo.cell.columnSpan);
    };
    TableUtilsEx.getColumnsRangeBySelectedCells = function (data) {
        return list_1.ListUtils.accumulate(data.rows, null, function (acc, rowInfo) {
            var currRowInterval = TableUtilsEx.getColumnsRangeBySelectedRow(data.info.gridInfoManager, rowInfo);
            return acc ? new boundary_1.BoundaryInterval(Math.max(currRowInterval.start, acc.start), Math.min(currRowInterval.end, acc.end)) : currRowInterval;
        });
    };
    return TableUtilsEx;
}());
exports.TableUtilsEx = TableUtilsEx;
